import { Trans } from '@lingui/react/macro';
import { memo, useContext } from 'react';

import type { SharedMessageProps } from './message';
import { Button } from '../../ui';
import { ChatRendererContext } from '../chat-renderer/chat-renderer-provider';

export interface StatusMessageProps extends SharedMessageProps {}

export const StatusMessage = memo(({ group }: StatusMessageProps) => {
  const { messages, isLast } = group;
  const context = useContext(ChatRendererContext);
  const isRetryable = messages.some(message => message.retryable === true);
  const showRetry = Boolean(isLast && isRetryable && context?.retry);

  return (
    <div className='my-2 flex flex-col items-center gap-2 px-4'>
      {messages.map(message => {
        if (!message.content) {
          return null;
        }

        return (
          <p
            className='text-center text-sm font-medium text-chat-muted-foreground'
            key={message.id}
          >
            {message.content}
          </p>
        );
      })}
      {showRetry && (
        <Button
          type='button'
          variant='outline'
          size='xs'
          disabled={context?.isFetching}
          onClick={() => {
            void context?.retry?.();
          }}
        >
          <Trans>Retry</Trans>
        </Button>
      )}
    </div>
  );
});
